export default __webpack_public_path__ + "aa584a58f81f4f5a8f70787a50d6f2da.png";